export const modalErrorSelectors = {
  getModalError: (state) => state.modalError.error,
  getModalErrorPreventPageReload: (state) => state.modalError.preventPageReload,
};
